import type { ReviewItem, ReviewResponse } from "./types";

export type ReviewFilter = "para_revisar" | "sin_responder" | "negativas" | "respondidas" | "todas";

export const latestResponse = (review: ReviewItem): ReviewResponse | null =>
  review.responses?.[0] || null;

const isActionableUnanswered = (review: ReviewItem): boolean =>
  review.public_response_status !== "publicada" && review.actionable !== false;

/** One canonical population for inbox tabs AND the Overview action recommendation. */
export const REVIEW_FILTERS: Array<[ReviewFilter, string, (review: ReviewItem) => boolean]> = [
  [
    "para_revisar",
    "Para revisar",
    (review) => isActionableUnanswered(review)
      && (latestResponse(review)?.status === "sugerida"
        || review.status === "delicada"
        || review.risk_level === "alto"),
  ],
  ["sin_responder", "Sin responder", isActionableUnanswered],
  ["negativas", "Negativas", (review) => review.rating <= 2 && isActionableUnanswered(review)],
  ["respondidas", "Respondidas", (review) => review.public_response_status === "publicada"],
  ["todas", "Todas", () => true],
];

export function reviewMatchesFilter(review: ReviewItem, filter: ReviewFilter): boolean {
  return (REVIEW_FILTERS.find(([key]) => key === filter)?.[2] || (() => false))(review);
}

export function isReviewFilter(value: string | null | undefined): value is ReviewFilter {
  return REVIEW_FILTERS.some(([key]) => key === value);
}

export function reviewFilterFromSearch(search: string): ReviewFilter | undefined {
  const value = new URLSearchParams(search).get("tab");
  return isReviewFilter(value) ? value : undefined;
}

export function defaultReviewFilter(reviews: ReviewItem[]): ReviewFilter {
  if (reviews.some((review) => reviewMatchesFilter(review, "para_revisar"))) return "para_revisar";
  if (reviews.some((review) => reviewMatchesFilter(review, "sin_responder"))) return "sin_responder";
  return "todas";
}
